import { ChargeableTripsList } from "../../api";
import * as ReduxToolkit from "@reduxjs/toolkit";
import { currentMonthStartEndString } from "../../utils/time";

export interface State {
    chargeableTrips?: ChargeableTripsList;
    startDate: string;
    endDate: string;
}

export function initState(): State {
    const d = currentMonthStartEndString();
    return {
        startDate: d.start,
        endDate: d.end,
    };
}

export const usageTripSlice = ReduxToolkit.createSlice({
    name: "usageTrip",
    initialState: initState(),
    reducers: {
        resetState: (state) => {
            state = initState();
            return state;
        },
        update_usage_trips: (
            state,
            action: ReduxToolkit.PayloadAction<ChargeableTripsList>
        ) => {
            state.chargeableTrips = action.payload;
            return state;
        },
        update_start_date: (
            state,
            action: ReduxToolkit.PayloadAction<string>
        ) => {
            state.startDate = action.payload;
            return state;
        },
        update_end_date: (
            state,
            action: ReduxToolkit.PayloadAction<string>
        ) => {
            state.endDate = action.payload;
            return state;
        },
    },
});
